module.exports = __webpack_public_path__ + "img/cptx6@2x.2bc6c0b5.png";